// @flow
import type { AxiosError } from "../helpers/types";
import type { LocalesData } from "../reducers/locales";

export const REQUEST_LOCALES = "REQUEST_LOCALES";
export const requestLocales = () => ({ type: REQUEST_LOCALES });

export const REQUEST_LOCALES_SUCCESS = "REQUEST_LOCALES_SUCCESS";
export const requestLocalesSuccess = (data: LocalesData) => ({
  type: REQUEST_LOCALES_SUCCESS,
  data
});

export const REQUEST_LOCALES_FAILED = "REQUEST_LOCALES_FAILED";
export const requestLocalesFailed = (error: AxiosError) => ({
  type: REQUEST_LOCALES_FAILED,
  error
});



// WEBPACK FOOTER //
// ./src/redux/actions/locales.js